// Multi-language translations for My Dummy Ticket
// Supported languages: English, German, Chinese, Portuguese, Arabic, Spanish, French

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
  { code: 'zh', name: '中文', flag: '🇨🇳', dir: 'ltr' },
  { code: 'pt', name: 'Português', flag: '🇧🇷', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'es', name: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' }
];

export const translations = {
  en: {
    // Header & Navigation
    nav: {
      howItWorks: 'How It Works',
      pricing: 'Pricing',
      templates: 'Templates',
      faq: 'FAQ',
      trackOrder: 'Track Order',
      login: 'Login',
      bookNow: 'Book Now',
      logout: 'Logout',
      myOrders: 'My Orders'
    },
    // Hero Section
    hero: {
      badge: 'Trusted by 50,000+ Travelers',
      title: 'Get Your Dummy Flight Ticket',
      titleHighlight: 'in Minutes',
      subtitle: 'Professional flight reservations for visa applications, proof of onward travel, and immigration requirements. Instant delivery via email.',
      cta: 'Create Your Ticket Now',
      ctaPrice: 'Starting from £6.99',
      trustBadge1: 'Instant Delivery',
      trustBadge2: 'Verifiable PNR',
      trustBadge3: 'Visa Approved'
    },
    // How It Works
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Get your dummy ticket in 3 simple steps',
      step1Title: 'Fill the Form',
      step1Desc: 'Enter your route, travel dates, and passenger details exactly as they appear on your passport.',
      step2Title: 'Make Payment',
      step2Desc: 'Secure payment via Stripe. We accept all major credit cards and digital wallets.',
      step3Title: 'Receive Ticket',
      step3Desc: 'Get your professional flight itinerary instantly via email.'
    },
    // Pricing Section
    pricingSection: {
      title: 'Simple, Transparent Pricing',
      subtitle: 'Choose the validity period that suits your needs',
      standard: 'Standard',
      verifiable: 'Verifiable',
      standardDesc: 'PDF itinerary, not verifiable online',
      verifiableDesc: 'Real PNR, verifiable on airline site',
      recommended: 'RECOMMENDED',
      hours: 'Hours',
      days: 'Days',
      from: 'from'
    },
    // Booking Form
    booking: {
      title: 'Book Your Dummy Ticket',
      documentType: 'Document Type',
      tripType: 'Trip Type',
      oneWay: 'One Way',
      roundTrip: 'Round Trip',
      validityPeriod: 'Validity Period',
      departureAirport: 'Departure Airport',
      arrivalAirport: 'Arrival Airport',
      departureDate: 'Departure Date',
      returnDate: 'Return Date',
      passengers: 'Passengers',
      addPassenger: '+ Add Passenger',
      primaryContact: 'Primary Contact',
      passenger: 'Passenger',
      firstName: 'First Name',
      lastName: 'Last Name',
      dateOfBirth: 'Date of Birth',
      nationality: 'Nationality',
      selectCountry: 'Select Country',
      mobileNumber: 'Mobile Number',
      phoneNumber: 'Phone Number',
      email: 'Email Address (for ticket delivery)',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone Number (optional)',
      phonePlaceholder: '+44 7700 900000',
      phoneHint: 'For account verification',
      adult: 'Adult',
      child: 'Child',
      infant: 'Infant',
      remove: 'Remove',
      proceedToPayment: 'Proceed to Secure Payment',
      securePayment: 'Secure payment via Stripe'
    },
    // Templates Section
    templates: {
      title: 'Professional Templates',
      subtitle: 'Our tickets look exactly like real airline confirmations',
      feature1: 'Airline Logo & Branding',
      feature2: 'Valid PNR Code',
      feature3: 'Barcode & QR Code',
      feature4: 'Flight Details'
    },
    // FAQ Section
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about dummy tickets'
    },
    // Track Order
    track: {
      title: 'Track Your Order',
      subtitle: 'Enter your order number or PNR code',
      placeholder: 'Order number or PNR code',
      button: 'Track Order',
      searching: 'Searching...'
    },
    // Footer
    footer: {
      tagline: 'Real flight reservations for visa applications. Trusted by 50,000+ travellers worldwide.',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      contact: 'Contact',
      home: 'Home',
      about: 'About Us',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      refund: 'Refund Policy',
      support: 'Support',
      allRightsReserved: 'All rights reserved.',
      disclaimer: 'Dummy tickets are for visa applications and proof of travel only. Not valid for actual travel.'
    },
    // Auth
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      orContinueWith: 'Or continue with'
    },
    // Orders
    orders: {
      title: 'My Orders',
      noOrders: 'No orders yet',
      orderNumber: 'Order #',
      pnr: 'PNR',
      route: 'Route',
      date: 'Date',
      status: 'Status',
      amount: 'Amount',
      download: 'Download PDF',
      viewDetails: 'View Details'
    },
    // Payment
    payment: {
      success: 'Payment Successful!',
      successMessage: 'Your dummy ticket has been generated and sent to your email.',
      failed: 'Payment Failed',
      failedMessage: 'Something went wrong. Please try again.',
      processing: 'Processing...',
      backToHome: 'Back to Home'
    },
    // Admin
    admin: {
      portal: 'Admin Portal',
      management: 'My Dummy Ticket Management',
      signIn: 'Sign In to Dashboard',
      email: 'Admin Email',
      password: 'Password',
      dashboard: 'Dashboard',
      totalOrders: 'TOTAL ORDERS',
      activeClients: 'ACTIVE CLIENTS',
      expiredClients: 'EXPIRED CLIENTS',
      totalRevenue: 'TOTAL REVENUE',
      allTimeBookings: 'All time bookings',
      validTickets: 'Valid tickets',
      pastValidity: 'Past validity',
      fromPaidOrders: 'From paid orders',
      paymentOverview: 'Payment Overview',
      success: 'Success',
      failed: 'Failed',
      pending: 'Pending',
      refunded: 'Refunded',
      notifications: 'Notifications',
      noNotifications: 'No new notifications',
      notifyMessage: "We'll notify you when something arrives",
      clearAll: 'Clear All',
      enquiries: 'Enquiries',
      logout: 'Logout'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      submit: 'Submit',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      or: 'or',
      and: 'and',
      from: 'from',
      to: 'to'
    },
    // SEO
    seo: {
      title: 'My Dummy Ticket - Dummy Flight Tickets for Visa Applications',
      description: 'Get professional dummy flight tickets for visa applications, proof of onward travel, and immigration requirements. Instant delivery, verifiable PNR codes. Trusted by 50,000+ travelers.',
      keywords: 'dummy ticket, dummy flight ticket, visa application, proof of onward travel, flight reservation, immigration, travel document, PNR code, flight itinerary'
    }
  },
  de: {
    nav: {
      howItWorks: 'So funktioniert es',
      pricing: 'Preise',
      templates: 'Vorlagen',
      faq: 'FAQ',
      trackOrder: 'Bestellung verfolgen',
      login: 'Anmelden',
      bookNow: 'Jetzt buchen',
      logout: 'Abmelden',
      myOrders: 'Meine Bestellungen'
    },
    hero: {
      badge: 'Vertraut von 50.000+ Reisenden',
      title: 'Holen Sie sich Ihr Dummy-Flugticket',
      titleHighlight: 'in Minuten',
      subtitle: 'Professionelle Flugreservierungen für Visumanträge, Nachweis der Weiterreise und Einwanderungsanforderungen. Sofortige Lieferung per E-Mail.',
      cta: 'Erstellen Sie jetzt Ihr Ticket',
      ctaPrice: 'Ab £6,99',
      trustBadge1: 'Sofortige Lieferung',
      trustBadge2: 'Überprüfbarer PNR',
      trustBadge3: 'Visa genehmigt'
    },
    howItWorks: {
      title: 'So funktioniert es',
      subtitle: 'Erhalten Sie Ihr Dummy-Ticket in 3 einfachen Schritten',
      step1Title: 'Formular ausfüllen',
      step1Desc: 'Geben Sie Ihre Route, Reisedaten und Passagierdaten genau wie in Ihrem Reisepass ein.',
      step2Title: 'Zahlung leisten',
      step2Desc: 'Sichere Zahlung über Stripe. Wir akzeptieren alle gängigen Kreditkarten und digitale Geldbörsen.',
      step3Title: 'Ticket erhalten',
      step3Desc: 'Erhalten Sie Ihren professionellen Flugplan sofort per E-Mail.'
    },
    pricingSection: {
      title: 'Einfache, transparente Preise',
      subtitle: 'Wählen Sie die Gültigkeitsdauer, die Ihren Bedürfnissen entspricht',
      standard: 'Standard',
      verifiable: 'Überprüfbar',
      standardDesc: 'PDF-Reiseplan, nicht online überprüfbar',
      verifiableDesc: 'Echter PNR, auf Airline-Website überprüfbar',
      recommended: 'EMPFOHLEN',
      hours: 'Stunden',
      days: 'Tage',
      from: 'ab'
    },
    booking: {
      title: 'Buchen Sie Ihr Dummy-Ticket',
      documentType: 'Dokumenttyp',
      tripType: 'Reiseart',
      oneWay: 'Einfache Fahrt',
      roundTrip: 'Hin- und Rückfahrt',
      validityPeriod: 'Gültigkeitsdauer',
      departureAirport: 'Abflughafen',
      arrivalAirport: 'Ankunftsflughafen',
      departureDate: 'Abflugdatum',
      returnDate: 'Rückflugdatum',
      passengers: 'Passagiere',
      addPassenger: '+ Passagier hinzufügen',
      primaryContact: 'Hauptkontakt',
      passenger: 'Passagier',
      firstName: 'Vorname',
      lastName: 'Nachname',
      dateOfBirth: 'Geburtsdatum',
      nationality: 'Nationalität',
      selectCountry: 'Land auswählen',
      mobileNumber: 'Handynummer',
      phoneNumber: 'Telefonnummer',
      email: 'E-Mail-Adresse (für Ticketzustellung)',
      emailPlaceholder: 'ihre@email.com',
      phone: 'Telefonnummer (optional)',
      phonePlaceholder: '+49 170 1234567',
      phoneHint: 'Zur Kontobestätigung',
      adult: 'Erwachsener',
      child: 'Kind',
      infant: 'Kleinkind',
      remove: 'Entfernen',
      proceedToPayment: 'Zur sicheren Zahlung',
      securePayment: 'Sichere Zahlung über Stripe'
    },
    templates: {
      title: 'Professionelle Vorlagen',
      subtitle: 'Unsere Tickets sehen genau wie echte Flugbestätigungen aus',
      feature1: 'Airline-Logo & Branding',
      feature2: 'Gültiger PNR-Code',
      feature3: 'Barcode & QR-Code',
      feature4: 'Flugdetails'
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      subtitle: 'Alles, was Sie über Dummy-Tickets wissen müssen'
    },
    track: {
      title: 'Bestellung verfolgen',
      subtitle: 'Geben Sie Ihre Bestellnummer oder Ihren PNR-Code ein',
      placeholder: 'Bestellnummer oder PNR-Code',
      button: 'Bestellung verfolgen',
      searching: 'Suche...'
    },
    footer: {
      tagline: 'Echte Flugreservierungen für Visumanträge. Vertraut von 50.000+ Reisenden weltweit.',
      quickLinks: 'Schnelllinks',
      legal: 'Rechtliches',
      contact: 'Kontakt',
      home: 'Startseite',
      about: 'Über uns',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen',
      refund: 'Rückerstattung',
      support: 'Support',
      allRightsReserved: 'Alle Rechte vorbehalten.',
      disclaimer: 'Dummy-Tickets sind nur für Visumanträge und Reisenachweis. Nicht gültig für tatsächliche Reisen.'
    },
    auth: {
      login: 'Anmelden',
      register: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      forgotPassword: 'Passwort vergessen?',
      noAccount: 'Noch kein Konto?',
      hasAccount: 'Bereits ein Konto?',
      signIn: 'Anmelden',
      signUp: 'Registrieren',
      orContinueWith: 'Oder weiter mit'
    },
    orders: {
      title: 'Meine Bestellungen',
      noOrders: 'Noch keine Bestellungen',
      orderNumber: 'Bestellung #',
      pnr: 'PNR',
      route: 'Route',
      date: 'Datum',
      status: 'Status',
      amount: 'Betrag',
      download: 'PDF herunterladen',
      viewDetails: 'Details anzeigen'
    },
    payment: {
      success: 'Zahlung erfolgreich!',
      successMessage: 'Ihr Dummy-Ticket wurde erstellt und an Ihre E-Mail gesendet.',
      failed: 'Zahlung fehlgeschlagen',
      failedMessage: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
      processing: 'Verarbeitung...',
      backToHome: 'Zurück zur Startseite'
    },
    admin: {
      portal: 'Admin-Portal',
      management: 'My Dummy Ticket Verwaltung',
      signIn: 'Zum Dashboard anmelden',
      email: 'Admin E-Mail',
      password: 'Passwort',
      dashboard: 'Dashboard',
      totalOrders: 'GESAMTBESTELLUNGEN',
      activeClients: 'AKTIVE KUNDEN',
      expiredClients: 'ABGELAUFENE KUNDEN',
      totalRevenue: 'GESAMTUMSATZ',
      allTimeBookings: 'Alle Buchungen',
      validTickets: 'Gültige Tickets',
      pastValidity: 'Abgelaufen',
      fromPaidOrders: 'Aus bezahlten Bestellungen',
      paymentOverview: 'Zahlungsübersicht',
      success: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      pending: 'Ausstehend',
      refunded: 'Erstattet',
      notifications: 'Benachrichtigungen',
      noNotifications: 'Keine neuen Benachrichtigungen',
      notifyMessage: 'Wir benachrichtigen Sie, wenn etwas eingeht',
      clearAll: 'Alle löschen',
      enquiries: 'Anfragen',
      logout: 'Abmelden'
    },
    common: {
      loading: 'Laden...',
      error: 'Fehler',
      success: 'Erfolg',
      submit: 'Absenden',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      view: 'Ansehen',
      close: 'Schließen',
      yes: 'Ja',
      no: 'Nein',
      or: 'oder',
      and: 'und',
      from: 'von',
      to: 'nach'
    },
    seo: {
      title: 'My Dummy Ticket - Dummy-Flugtickets für Visumanträge',
      description: 'Erhalten Sie professionelle Dummy-Flugtickets für Visumanträge, Nachweis der Weiterreise und Einwanderungsanforderungen. Sofortige Lieferung, überprüfbare PNR-Codes.',
      keywords: 'dummy ticket, dummy flugticket, visumantrag, weiterreisenachweis, flugreservierung, einwanderung, reisedokument, PNR code'
    }
  },
  zh: {
    nav: {
      howItWorks: '如何运作',
      pricing: '价格',
      templates: '模板',
      faq: '常见问题',
      trackOrder: '追踪订单',
      login: '登录',
      bookNow: '立即预订',
      logout: '退出',
      myOrders: '我的订单'
    },
    hero: {
      badge: '受到50,000+旅客信赖',
      title: '获取您的虚拟机票',
      titleHighlight: '仅需几分钟',
      subtitle: '专业的航班预订服务，用于签证申请、出境证明和移民要求。通过电子邮件即时送达。',
      cta: '立即创建您的机票',
      ctaPrice: '起价 £6.99',
      trustBadge1: '即时送达',
      trustBadge2: '可验证PNR',
      trustBadge3: '签证认可'
    },
    howItWorks: {
      title: '如何运作',
      subtitle: '简单3步获取您的虚拟机票',
      step1Title: '填写表格',
      step1Desc: '输入您的路线、旅行日期和乘客信息，与护照上完全一致。',
      step2Title: '完成付款',
      step2Desc: '通过Stripe安全支付。我们接受所有主要信用卡和数字钱包。',
      step3Title: '接收机票',
      step3Desc: '通过电子邮件即时获取您的专业航班行程单。'
    },
    pricingSection: {
      title: '简单透明的定价',
      subtitle: '选择适合您需求的有效期',
      standard: '标准版',
      verifiable: '可验证版',
      standardDesc: 'PDF行程单，不可在线验证',
      verifiableDesc: '真实PNR，可在航空公司网站验证',
      recommended: '推荐',
      hours: '小时',
      days: '天',
      from: '起价'
    },
    booking: {
      title: '预订您的虚拟机票',
      documentType: '文档类型',
      tripType: '行程类型',
      oneWay: '单程',
      roundTrip: '往返',
      validityPeriod: '有效期',
      departureAirport: '出发机场',
      arrivalAirport: '到达机场',
      departureDate: '出发日期',
      returnDate: '返回日期',
      passengers: '乘客',
      addPassenger: '+ 添加乘客',
      primaryContact: '主要联系人',
      passenger: '乘客',
      firstName: '名',
      lastName: '姓',
      dateOfBirth: '出生日期',
      nationality: '国籍',
      selectCountry: '选择国家',
      mobileNumber: '手机号码',
      phoneNumber: '电话号码',
      email: '电子邮箱（用于机票发送）',
      emailPlaceholder: 'your@email.com',
      phone: '电话号码（可选）',
      phonePlaceholder: '+86 138 0000 0000',
      phoneHint: '用于账户验证',
      adult: '成人',
      child: '儿童',
      infant: '婴儿',
      remove: '移除',
      proceedToPayment: '前往安全支付',
      securePayment: '通过Stripe安全支付'
    },
    templates: {
      title: '专业模板',
      subtitle: '我们的机票看起来与真正的航空公司确认函一模一样',
      feature1: '航空公司标志和品牌',
      feature2: '有效PNR代码',
      feature3: '条形码和二维码',
      feature4: '航班详情'
    },
    faq: {
      title: '常见问题',
      subtitle: '关于虚拟机票您需要了解的一切'
    },
    track: {
      title: '追踪您的订单',
      subtitle: '输入您的订单号或PNR代码',
      placeholder: '订单号或PNR代码',
      button: '追踪订单',
      searching: '搜索中...'
    },
    footer: {
      tagline: '用于签证申请的真实航班预订。受到全球50,000+旅客信赖。',
      quickLinks: '快速链接',
      legal: '法律条款',
      contact: '联系我们',
      home: '首页',
      about: '关于我们',
      privacy: '隐私政策',
      terms: '服务条款',
      refund: '退款政策',
      support: '客户支持',
      allRightsReserved: '版权所有。',
      disclaimer: '虚拟机票仅用于签证申请和旅行证明。不可用于实际旅行。'
    },
    auth: {
      login: '登录',
      register: '注册',
      email: '电子邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      forgotPassword: '忘记密码？',
      noAccount: '没有账户？',
      hasAccount: '已有账户？',
      signIn: '登录',
      signUp: '注册',
      orContinueWith: '或继续使用'
    },
    orders: {
      title: '我的订单',
      noOrders: '暂无订单',
      orderNumber: '订单 #',
      pnr: 'PNR',
      route: '路线',
      date: '日期',
      status: '状态',
      amount: '金额',
      download: '下载PDF',
      viewDetails: '查看详情'
    },
    payment: {
      success: '支付成功！',
      successMessage: '您的虚拟机票已生成并发送到您的邮箱。',
      failed: '支付失败',
      failedMessage: '出现问题，请重试。',
      processing: '处理中...',
      backToHome: '返回首页'
    },
    admin: {
      portal: '管理门户',
      management: 'My Dummy Ticket 管理',
      signIn: '登录到仪表板',
      email: '管理员邮箱',
      password: '密码',
      dashboard: '仪表板',
      totalOrders: '总订单',
      activeClients: '活跃客户',
      expiredClients: '过期客户',
      totalRevenue: '总收入',
      allTimeBookings: '所有预订',
      validTickets: '有效机票',
      pastValidity: '已过期',
      fromPaidOrders: '来自已付款订单',
      paymentOverview: '支付概览',
      success: '成功',
      failed: '失败',
      pending: '待处理',
      refunded: '已退款',
      notifications: '通知',
      noNotifications: '暂无新通知',
      notifyMessage: '有新消息时我们会通知您',
      clearAll: '清除全部',
      enquiries: '询问',
      logout: '退出'
    },
    common: {
      loading: '加载中...',
      error: '错误',
      success: '成功',
      submit: '提交',
      cancel: '取消',
      save: '保存',
      delete: '删除',
      edit: '编辑',
      view: '查看',
      close: '关闭',
      yes: '是',
      no: '否',
      or: '或',
      and: '和',
      from: '从',
      to: '到'
    },
    seo: {
      title: 'My Dummy Ticket - 签证申请虚拟机票',
      description: '获取专业的虚拟机票，用于签证申请、出境证明和移民要求。即时送达，可验证的PNR代码。受到50,000+旅客信赖。',
      keywords: '虚拟机票, 签证申请, 出境证明, 航班预订, 移民, 旅行文件, PNR代码'
    }
  },
  pt: {
    nav: {
      howItWorks: 'Como Funciona',
      pricing: 'Preços',
      templates: 'Modelos',
      faq: 'FAQ',
      trackOrder: 'Rastrear Pedido',
      login: 'Entrar',
      bookNow: 'Reserve Agora',
      logout: 'Sair',
      myOrders: 'Meus Pedidos'
    },
    hero: {
      badge: 'Confiado por 50.000+ Viajantes',
      title: 'Obtenha seu Bilhete de Avião Fictício',
      titleHighlight: 'em Minutos',
      subtitle: 'Reservas de voo profissionais para solicitações de visto, comprovante de viagem de ida e requisitos de imigração. Entrega instantânea por e-mail.',
      cta: 'Crie seu Bilhete Agora',
      ctaPrice: 'A partir de £6,99',
      trustBadge1: 'Entrega Instantânea',
      trustBadge2: 'PNR Verificável',
      trustBadge3: 'Aprovado para Visto'
    },
    howItWorks: {
      title: 'Como Funciona',
      subtitle: 'Obtenha seu bilhete fictício em 3 passos simples',
      step1Title: 'Preencha o Formulário',
      step1Desc: 'Insira sua rota, datas de viagem e dados dos passageiros exatamente como aparecem no passaporte.',
      step2Title: 'Faça o Pagamento',
      step2Desc: 'Pagamento seguro via Stripe. Aceitamos todos os principais cartões de crédito e carteiras digitais.',
      step3Title: 'Receba o Bilhete',
      step3Desc: 'Receba seu itinerário de voo profissional instantaneamente por e-mail.'
    },
    pricingSection: {
      title: 'Preços Simples e Transparentes',
      subtitle: 'Escolha o período de validade que atende às suas necessidades',
      standard: 'Padrão',
      verifiable: 'Verificável',
      standardDesc: 'Itinerário PDF, não verificável online',
      verifiableDesc: 'PNR real, verificável no site da companhia aérea',
      recommended: 'RECOMENDADO',
      hours: 'Horas',
      days: 'Dias',
      from: 'a partir de'
    },
    booking: {
      title: 'Reserve seu Bilhete Fictício',
      documentType: 'Tipo de Documento',
      tripType: 'Tipo de Viagem',
      oneWay: 'Só Ida',
      roundTrip: 'Ida e Volta',
      validityPeriod: 'Período de Validade',
      departureAirport: 'Aeroporto de Partida',
      arrivalAirport: 'Aeroporto de Chegada',
      departureDate: 'Data de Partida',
      returnDate: 'Data de Retorno',
      passengers: 'Passageiros',
      addPassenger: '+ Adicionar Passageiro',
      primaryContact: 'Contato Principal',
      passenger: 'Passageiro',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      dateOfBirth: 'Data de Nascimento',
      nationality: 'Nacionalidade',
      selectCountry: 'Selecionar País',
      mobileNumber: 'Número de Celular',
      phoneNumber: 'Número de Telefone',
      email: 'Endereço de E-mail (para entrega do bilhete)',
      emailPlaceholder: 'seu@email.com',
      phone: 'Telefone (opcional)',
      phonePlaceholder: '+55 11 99999-9999',
      phoneHint: 'Para verificação de conta',
      adult: 'Adulto',
      child: 'Criança',
      infant: 'Bebê',
      remove: 'Remover',
      proceedToPayment: 'Prosseguir para Pagamento Seguro',
      securePayment: 'Pagamento seguro via Stripe'
    },
    templates: {
      title: 'Modelos Profissionais',
      subtitle: 'Nossos bilhetes são idênticos às confirmações reais de companhias aéreas',
      feature1: 'Logo e Marca da Companhia',
      feature2: 'Código PNR Válido',
      feature3: 'Código de Barras e QR',
      feature4: 'Detalhes do Voo'
    },
    faq: {
      title: 'Perguntas Frequentes',
      subtitle: 'Tudo o que você precisa saber sobre bilhetes fictícios'
    },
    track: {
      title: 'Rastrear seu Pedido',
      subtitle: 'Digite seu número de pedido ou código PNR',
      placeholder: 'Número do pedido ou código PNR',
      button: 'Rastrear Pedido',
      searching: 'Buscando...'
    },
    footer: {
      tagline: 'Reservas de voo reais para solicitações de visto. Confiado por 50.000+ viajantes em todo o mundo.',
      quickLinks: 'Links Rápidos',
      legal: 'Legal',
      contact: 'Contato',
      home: 'Início',
      about: 'Sobre Nós',
      privacy: 'Política de Privacidade',
      terms: 'Termos de Serviço',
      refund: 'Política de Reembolso',
      support: 'Suporte',
      allRightsReserved: 'Todos os direitos reservados.',
      disclaimer: 'Bilhetes fictícios são apenas para solicitações de visto e comprovante de viagem. Não válido para viagem real.'
    },
    auth: {
      login: 'Entrar',
      register: 'Registrar',
      email: 'E-mail',
      password: 'Senha',
      confirmPassword: 'Confirmar Senha',
      forgotPassword: 'Esqueceu a Senha?',
      noAccount: 'Não tem uma conta?',
      hasAccount: 'Já tem uma conta?',
      signIn: 'Entrar',
      signUp: 'Registrar',
      orContinueWith: 'Ou continue com'
    },
    orders: {
      title: 'Meus Pedidos',
      noOrders: 'Nenhum pedido ainda',
      orderNumber: 'Pedido #',
      pnr: 'PNR',
      route: 'Rota',
      date: 'Data',
      status: 'Status',
      amount: 'Valor',
      download: 'Baixar PDF',
      viewDetails: 'Ver Detalhes'
    },
    payment: {
      success: 'Pagamento Bem-sucedido!',
      successMessage: 'Seu bilhete fictício foi gerado e enviado para seu e-mail.',
      failed: 'Pagamento Falhou',
      failedMessage: 'Algo deu errado. Por favor, tente novamente.',
      processing: 'Processando...',
      backToHome: 'Voltar ao Início'
    },
    admin: {
      portal: 'Portal Admin',
      management: 'Gerenciamento My Dummy Ticket',
      signIn: 'Entrar no Painel',
      email: 'E-mail Admin',
      password: 'Senha',
      dashboard: 'Painel',
      totalOrders: 'TOTAL DE PEDIDOS',
      activeClients: 'CLIENTES ATIVOS',
      expiredClients: 'CLIENTES EXPIRADOS',
      totalRevenue: 'RECEITA TOTAL',
      allTimeBookings: 'Todas as reservas',
      validTickets: 'Bilhetes válidos',
      pastValidity: 'Validade passada',
      fromPaidOrders: 'De pedidos pagos',
      paymentOverview: 'Visão de Pagamentos',
      success: 'Sucesso',
      failed: 'Falhou',
      pending: 'Pendente',
      refunded: 'Reembolsado',
      notifications: 'Notificações',
      noNotifications: 'Sem novas notificações',
      notifyMessage: 'Notificaremos quando algo chegar',
      clearAll: 'Limpar Tudo',
      enquiries: 'Consultas',
      logout: 'Sair'
    },
    common: {
      loading: 'Carregando...',
      error: 'Erro',
      success: 'Sucesso',
      submit: 'Enviar',
      cancel: 'Cancelar',
      save: 'Salvar',
      delete: 'Excluir',
      edit: 'Editar',
      view: 'Ver',
      close: 'Fechar',
      yes: 'Sim',
      no: 'Não',
      or: 'ou',
      and: 'e',
      from: 'de',
      to: 'para'
    },
    seo: {
      title: 'My Dummy Ticket - Bilhetes de Avião Fictícios para Visto',
      description: 'Obtenha bilhetes de avião fictícios profissionais para solicitações de visto, comprovante de viagem e requisitos de imigração. Entrega instantânea, códigos PNR verificáveis.',
      keywords: 'bilhete fictício, passagem aérea fictícia, solicitação de visto, comprovante de viagem, reserva de voo, imigração, documento de viagem, código PNR'
    }
  },
  ar: {
    nav: {
      howItWorks: 'كيف يعمل',
      pricing: 'الأسعار',
      templates: 'القوالب',
      faq: 'الأسئلة الشائعة',
      trackOrder: 'تتبع الطلب',
      login: 'تسجيل الدخول',
      bookNow: 'احجز الآن',
      logout: 'تسجيل الخروج',
      myOrders: 'طلباتي'
    },
    hero: {
      badge: 'موثوق من قبل 50,000+ مسافر',
      title: 'احصل على تذكرة طيران وهمية',
      titleHighlight: 'في دقائق',
      subtitle: 'حجوزات طيران احترافية لطلبات التأشيرة وإثبات السفر ومتطلبات الهجرة. التسليم الفوري عبر البريد الإلكتروني والرسائل القصيرة وواتساب.',
      cta: 'أنشئ تذكرتك الآن',
      ctaPrice: 'ابتداءً من £6.99',
      trustBadge1: 'تسليم فوري',
      trustBadge2: 'PNR قابل للتحقق',
      trustBadge3: 'معتمد للتأشيرة'
    },
    howItWorks: {
      title: 'كيف يعمل',
      subtitle: 'احصل على تذكرتك الوهمية في 3 خطوات بسيطة',
      step1Title: 'املأ النموذج',
      step1Desc: 'أدخل مسارك وتواريخ السفر وتفاصيل الركاب تماماً كما تظهر في جواز سفرك.',
      step2Title: 'قم بالدفع',
      step2Desc: 'دفع آمن عبر Stripe. نقبل جميع بطاقات الائتمان الرئيسية والمحافظ الرقمية.',
      step3Title: 'استلم التذكرة',
      step3Desc: 'احصل على جدول رحلتك الاحترافي فوراً عبر البريد الإلكتروني والرسائل القصيرة وواتساب.'
    },
    pricingSection: {
      title: 'أسعار بسيطة وشفافة',
      subtitle: 'اختر فترة الصلاحية التي تناسب احتياجاتك',
      standard: 'قياسي',
      verifiable: 'قابل للتحقق',
      standardDesc: 'جدول PDF، غير قابل للتحقق عبر الإنترنت',
      verifiableDesc: 'PNR حقيقي، قابل للتحقق على موقع شركة الطيران',
      recommended: 'موصى به',
      hours: 'ساعات',
      days: 'أيام',
      from: 'من'
    },
    booking: {
      title: 'احجز تذكرتك الوهمية',
      documentType: 'نوع المستند',
      tripType: 'نوع الرحلة',
      oneWay: 'ذهاب فقط',
      roundTrip: 'ذهاب وعودة',
      validityPeriod: 'فترة الصلاحية',
      departureAirport: 'مطار المغادرة',
      arrivalAirport: 'مطار الوصول',
      departureDate: 'تاريخ المغادرة',
      returnDate: 'تاريخ العودة',
      passengers: 'الركاب',
      addPassenger: '+ إضافة راكب',
      primaryContact: 'جهة الاتصال الرئيسية',
      passenger: 'راكب',
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      dateOfBirth: 'تاريخ الميلاد',
      nationality: 'الجنسية',
      selectCountry: 'اختر الدولة',
      mobileNumber: 'رقم الهاتف المحمول',
      phoneNumber: 'رقم الهاتف',
      email: 'البريد الإلكتروني (لتسليم التذكرة)',
      emailPlaceholder: 'your@email.com',
      phone: 'رقم الهاتف (اختياري - للرسائل القصيرة/واتساب)',
      phonePlaceholder: '+966 50 000 0000',
      phoneHint: 'احصل على تأكيد فوري عبر الرسائل القصيرة وواتساب',
      adult: 'بالغ',
      child: 'طفل',
      infant: 'رضيع',
      remove: 'إزالة',
      proceedToPayment: 'المتابعة للدفع الآمن',
      securePayment: 'دفع آمن عبر Stripe'
    },
    templates: {
      title: 'قوالب احترافية',
      subtitle: 'تذاكرنا تبدو تماماً مثل تأكيدات شركات الطيران الحقيقية',
      feature1: 'شعار وعلامة شركة الطيران',
      feature2: 'رمز PNR صالح',
      feature3: 'باركود ورمز QR',
      feature4: 'تفاصيل الرحلة'
    },
    faq: {
      title: 'الأسئلة الشائعة',
      subtitle: 'كل ما تحتاج معرفته عن التذاكر الوهمية'
    },
    track: {
      title: 'تتبع طلبك',
      subtitle: 'أدخل رقم طلبك أو رمز PNR',
      placeholder: 'رقم الطلب أو رمز PNR',
      button: 'تتبع الطلب',
      searching: 'جاري البحث...'
    },
    footer: {
      tagline: 'حجوزات طيران حقيقية لطلبات التأشيرة. موثوق من قبل 50,000+ مسافر حول العالم.',
      quickLinks: 'روابط سريعة',
      legal: 'قانوني',
      contact: 'اتصل بنا',
      home: 'الرئيسية',
      about: 'من نحن',
      privacy: 'سياسة الخصوصية',
      terms: 'شروط الخدمة',
      refund: 'سياسة الاسترداد',
      support: 'الدعم',
      allRightsReserved: 'جميع الحقوق محفوظة.',
      disclaimer: 'التذاكر الوهمية مخصصة فقط لطلبات التأشيرة وإثبات السفر. غير صالحة للسفر الفعلي.'
    },
    auth: {
      login: 'تسجيل الدخول',
      register: 'التسجيل',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      forgotPassword: 'نسيت كلمة المرور؟',
      noAccount: 'ليس لديك حساب؟',
      hasAccount: 'لديك حساب بالفعل؟',
      signIn: 'تسجيل الدخول',
      signUp: 'التسجيل',
      orContinueWith: 'أو تابع مع'
    },
    orders: {
      title: 'طلباتي',
      noOrders: 'لا توجد طلبات بعد',
      orderNumber: 'طلب #',
      pnr: 'PNR',
      route: 'المسار',
      date: 'التاريخ',
      status: 'الحالة',
      amount: 'المبلغ',
      download: 'تحميل PDF',
      viewDetails: 'عرض التفاصيل'
    },
    payment: {
      success: 'تم الدفع بنجاح!',
      successMessage: 'تم إنشاء تذكرتك الوهمية وإرسالها إلى بريدك الإلكتروني.',
      failed: 'فشل الدفع',
      failedMessage: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
      processing: 'جاري المعالجة...',
      backToHome: 'العودة للرئيسية'
    },
    admin: {
      portal: 'بوابة الإدارة',
      management: 'إدارة My Dummy Ticket',
      signIn: 'تسجيل الدخول للوحة التحكم',
      email: 'بريد المدير',
      password: 'كلمة المرور',
      dashboard: 'لوحة التحكم',
      totalOrders: 'إجمالي الطلبات',
      activeClients: 'العملاء النشطون',
      expiredClients: 'العملاء المنتهية صلاحيتهم',
      totalRevenue: 'إجمالي الإيرادات',
      allTimeBookings: 'جميع الحجوزات',
      validTickets: 'التذاكر الصالحة',
      pastValidity: 'منتهية الصلاحية',
      fromPaidOrders: 'من الطلبات المدفوعة',
      paymentOverview: 'نظرة عامة على المدفوعات',
      success: 'ناجح',
      failed: 'فاشل',
      pending: 'قيد الانتظار',
      refunded: 'مسترد',
      notifications: 'الإشعارات',
      noNotifications: 'لا توجد إشعارات جديدة',
      notifyMessage: 'سنعلمك عند وصول شيء ما',
      clearAll: 'مسح الكل',
      enquiries: 'الاستفسارات',
      logout: 'تسجيل الخروج'
    },
    common: {
      loading: 'جاري التحميل...',
      error: 'خطأ',
      success: 'نجاح',
      submit: 'إرسال',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
      edit: 'تعديل',
      view: 'عرض',
      close: 'إغلاق',
      yes: 'نعم',
      no: 'لا',
      or: 'أو',
      and: 'و',
      from: 'من',
      to: 'إلى'
    },
    seo: {
      title: 'My Dummy Ticket - تذاكر طيران وهمية لطلبات التأشيرة',
      description: 'احصل على تذاكر طيران وهمية احترافية لطلبات التأشيرة وإثبات السفر ومتطلبات الهجرة. تسليم فوري، رموز PNR قابلة للتحقق.',
      keywords: 'تذكرة وهمية, تذكرة طيران وهمية, طلب تأشيرة, إثبات السفر, حجز طيران, هجرة, وثيقة سفر, رمز PNR'
    }
  },
  es: {
    nav: {
      howItWorks: 'Cómo Funciona',
      pricing: 'Precios',
      templates: 'Plantillas',
      faq: 'FAQ',
      trackOrder: 'Rastrear Pedido',
      login: 'Iniciar Sesión',
      bookNow: 'Reservar Ahora',
      logout: 'Cerrar Sesión',
      myOrders: 'Mis Pedidos'
    },
    hero: {
      badge: 'Confiado por 50,000+ Viajeros',
      title: 'Obtén tu Boleto de Avión Ficticio',
      titleHighlight: 'en Minutos',
      subtitle: 'Reservas de vuelo profesionales para solicitudes de visa, prueba de viaje de salida y requisitos de inmigración. Entrega instantánea por correo electrónico.',
      cta: 'Crea tu Boleto Ahora',
      ctaPrice: 'Desde £6.99',
      trustBadge1: 'Entrega Instantánea',
      trustBadge2: 'PNR Verificable',
      trustBadge3: 'Aprobado para Visa'
    },
    howItWorks: {
      title: 'Cómo Funciona',
      subtitle: 'Obtén tu boleto ficticio en 3 simples pasos',
      step1Title: 'Llena el Formulario',
      step1Desc: 'Ingresa tu ruta, fechas de viaje y datos de pasajeros exactamente como aparecen en tu pasaporte.',
      step2Title: 'Realiza el Pago',
      step2Desc: 'Pago seguro vía Stripe. Aceptamos todas las tarjetas de crédito principales y billeteras digitales.',
      step3Title: 'Recibe el Boleto',
      step3Desc: 'Recibe tu itinerario de vuelo profesional instantáneamente por correo electrónico.'
    },
    pricingSection: {
      title: 'Precios Simples y Transparentes',
      subtitle: 'Elige el período de validez que se adapte a tus necesidades',
      standard: 'Estándar',
      verifiable: 'Verificable',
      standardDesc: 'Itinerario PDF, no verificable en línea',
      verifiableDesc: 'PNR real, verificable en el sitio de la aerolínea',
      recommended: 'RECOMENDADO',
      hours: 'Horas',
      days: 'Días',
      from: 'desde'
    },
    booking: {
      title: 'Reserva tu Boleto Ficticio',
      documentType: 'Tipo de Documento',
      tripType: 'Tipo de Viaje',
      oneWay: 'Solo Ida',
      roundTrip: 'Ida y Vuelta',
      validityPeriod: 'Período de Validez',
      departureAirport: 'Aeropuerto de Salida',
      arrivalAirport: 'Aeropuerto de Llegada',
      departureDate: 'Fecha de Salida',
      returnDate: 'Fecha de Regreso',
      passengers: 'Pasajeros',
      addPassenger: '+ Agregar Pasajero',
      primaryContact: 'Contacto Principal',
      passenger: 'Pasajero',
      firstName: 'Nombre',
      lastName: 'Apellido',
      dateOfBirth: 'Fecha de Nacimiento',
      nationality: 'Nacionalidad',
      selectCountry: 'Seleccionar País',
      mobileNumber: 'Número de Celular',
      phoneNumber: 'Número de Teléfono',
      email: 'Correo Electrónico (para entrega del boleto)',
      emailPlaceholder: 'tu@email.com',
      phone: 'Teléfono (opcional)',
      phonePlaceholder: '+34 600 000 000',
      phoneHint: 'Para verificación de cuenta',
      adult: 'Adulto',
      child: 'Niño',
      infant: 'Bebé',
      remove: 'Eliminar',
      proceedToPayment: 'Proceder al Pago Seguro',
      securePayment: 'Pago seguro vía Stripe'
    },
    templates: {
      title: 'Plantillas Profesionales',
      subtitle: 'Nuestros boletos lucen exactamente como confirmaciones reales de aerolíneas',
      feature1: 'Logo y Marca de Aerolínea',
      feature2: 'Código PNR Válido',
      feature3: 'Código de Barras y QR',
      feature4: 'Detalles del Vuelo'
    },
    faq: {
      title: 'Preguntas Frecuentes',
      subtitle: 'Todo lo que necesitas saber sobre boletos ficticios'
    },
    track: {
      title: 'Rastrear tu Pedido',
      subtitle: 'Ingresa tu número de pedido o código PNR',
      placeholder: 'Número de pedido o código PNR',
      button: 'Rastrear Pedido',
      searching: 'Buscando...'
    },
    footer: {
      tagline: 'Reservas de vuelo reales para solicitudes de visa. Confiado por 50,000+ viajeros en todo el mundo.',
      quickLinks: 'Enlaces Rápidos',
      legal: 'Legal',
      contact: 'Contacto',
      home: 'Inicio',
      about: 'Sobre Nosotros',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      refund: 'Política de Reembolso',
      support: 'Soporte',
      allRightsReserved: 'Todos los derechos reservados.',
      disclaimer: 'Los boletos ficticios son solo para solicitudes de visa y prueba de viaje. No válido para viaje real.'
    },
    auth: {
      login: 'Iniciar Sesión',
      register: 'Registrarse',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      forgotPassword: '¿Olvidaste tu Contraseña?',
      noAccount: '¿No tienes cuenta?',
      hasAccount: '¿Ya tienes cuenta?',
      signIn: 'Iniciar Sesión',
      signUp: 'Registrarse',
      orContinueWith: 'O continúa con'
    },
    orders: {
      title: 'Mis Pedidos',
      noOrders: 'Sin pedidos aún',
      orderNumber: 'Pedido #',
      pnr: 'PNR',
      route: 'Ruta',
      date: 'Fecha',
      status: 'Estado',
      amount: 'Monto',
      download: 'Descargar PDF',
      viewDetails: 'Ver Detalles'
    },
    payment: {
      success: '¡Pago Exitoso!',
      successMessage: 'Tu boleto ficticio ha sido generado y enviado a tu correo.',
      failed: 'Pago Fallido',
      failedMessage: 'Algo salió mal. Por favor intenta de nuevo.',
      processing: 'Procesando...',
      backToHome: 'Volver al Inicio'
    },
    admin: {
      portal: 'Portal de Admin',
      management: 'Gestión My Dummy Ticket',
      signIn: 'Iniciar Sesión en Panel',
      email: 'Email de Admin',
      password: 'Contraseña',
      dashboard: 'Panel',
      totalOrders: 'TOTAL DE PEDIDOS',
      activeClients: 'CLIENTES ACTIVOS',
      expiredClients: 'CLIENTES EXPIRADOS',
      totalRevenue: 'INGRESOS TOTALES',
      allTimeBookings: 'Todas las reservas',
      validTickets: 'Boletos válidos',
      pastValidity: 'Validez pasada',
      fromPaidOrders: 'De pedidos pagados',
      paymentOverview: 'Resumen de Pagos',
      success: 'Éxito',
      failed: 'Fallido',
      pending: 'Pendiente',
      refunded: 'Reembolsado',
      notifications: 'Notificaciones',
      noNotifications: 'Sin nuevas notificaciones',
      notifyMessage: 'Te notificaremos cuando llegue algo',
      clearAll: 'Limpiar Todo',
      enquiries: 'Consultas',
      logout: 'Cerrar Sesión'
    },
    common: {
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      submit: 'Enviar',
      cancel: 'Cancelar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      view: 'Ver',
      close: 'Cerrar',
      yes: 'Sí',
      no: 'No',
      or: 'o',
      and: 'y',
      from: 'de',
      to: 'a'
    },
    seo: {
      title: 'My Dummy Ticket - Boletos de Avión Ficticios para Visa',
      description: 'Obtén boletos de avión ficticios profesionales para solicitudes de visa, prueba de viaje y requisitos de inmigración. Entrega instantánea, códigos PNR verificables.',
      keywords: 'boleto ficticio, boleto de avión ficticio, solicitud de visa, prueba de viaje, reserva de vuelo, inmigración, documento de viaje, código PNR'
    }
  },
  fr: {
    nav: {
      howItWorks: 'Comment ça marche',
      pricing: 'Tarifs',
      templates: 'Modèles',
      faq: 'FAQ',
      trackOrder: 'Suivre la commande',
      login: 'Connexion',
      bookNow: 'Réserver',
      logout: 'Déconnexion',
      myOrders: 'Mes commandes'
    },
    hero: {
      badge: 'Confiance de 50 000+ voyageurs',
      title: 'Obtenez votre billet d\'avion fictif',
      titleHighlight: 'en quelques minutes',
      subtitle: 'Réservations de vol professionnelles pour les demandes de visa, preuve de voyage de continuation et exigences d\'immigration. Livraison instantanée par e-mail.',
      cta: 'Créez votre billet maintenant',
      ctaPrice: 'À partir de £6,99',
      trustBadge1: 'Livraison instantanée',
      trustBadge2: 'PNR vérifiable',
      trustBadge3: 'Approuvé pour visa'
    },
    howItWorks: {
      title: 'Comment ça marche',
      subtitle: 'Obtenez votre billet fictif en 3 étapes simples',
      step1Title: 'Remplissez le formulaire',
      step1Desc: 'Entrez votre itinéraire, dates de voyage et informations passagers exactement comme sur votre passeport.',
      step2Title: 'Effectuez le paiement',
      step2Desc: 'Paiement sécurisé via Stripe. Nous acceptons toutes les cartes de crédit et portefeuilles numériques.',
      step3Title: 'Recevez le billet',
      step3Desc: 'Recevez votre itinéraire de vol professionnel instantanément par e-mail.'
    },
    pricingSection: {
      title: 'Tarifs simples et transparents',
      subtitle: 'Choisissez la période de validité qui vous convient',
      standard: 'Standard',
      verifiable: 'Vérifiable',
      standardDesc: 'Itinéraire PDF, non vérifiable en ligne',
      verifiableDesc: 'PNR réel, vérifiable sur le site de la compagnie',
      recommended: 'RECOMMANDÉ',
      hours: 'Heures',
      days: 'Jours',
      from: 'à partir de'
    },
    booking: {
      title: 'Réservez votre billet fictif',
      documentType: 'Type de document',
      tripType: 'Type de voyage',
      oneWay: 'Aller simple',
      roundTrip: 'Aller-retour',
      validityPeriod: 'Période de validité',
      departureAirport: 'Aéroport de départ',
      arrivalAirport: 'Aéroport d\'arrivée',
      departureDate: 'Date de départ',
      returnDate: 'Date de retour',
      passengers: 'Passagers',
      addPassenger: '+ Ajouter un passager',
      primaryContact: 'Contact principal',
      passenger: 'Passager',
      firstName: 'Prénom',
      lastName: 'Nom',
      dateOfBirth: 'Date de naissance',
      nationality: 'Nationalité',
      selectCountry: 'Sélectionner le pays',
      mobileNumber: 'Numéro de mobile',
      phoneNumber: 'Numéro de téléphone',
      email: 'Adresse e-mail (pour la livraison du billet)',
      emailPlaceholder: 'votre@email.com',
      phone: 'Téléphone (optionnel)',
      phonePlaceholder: '+33 6 00 00 00 00',
      phoneHint: 'Pour vérification de compte',
      adult: 'Adulte',
      child: 'Enfant',
      infant: 'Bébé',
      remove: 'Supprimer',
      proceedToPayment: 'Procéder au paiement sécurisé',
      securePayment: 'Paiement sécurisé via Stripe'
    },
    templates: {
      title: 'Modèles professionnels',
      subtitle: 'Nos billets ressemblent exactement aux confirmations réelles des compagnies aériennes',
      feature1: 'Logo et marque de la compagnie',
      feature2: 'Code PNR valide',
      feature3: 'Code-barres et QR',
      feature4: 'Détails du vol'
    },
    faq: {
      title: 'Questions fréquentes',
      subtitle: 'Tout ce que vous devez savoir sur les billets fictifs'
    },
    track: {
      title: 'Suivre votre commande',
      subtitle: 'Entrez votre numéro de commande ou code PNR',
      placeholder: 'Numéro de commande ou code PNR',
      button: 'Suivre la commande',
      searching: 'Recherche...'
    },
    footer: {
      tagline: 'Réservations de vol réelles pour les demandes de visa. Confiance de 50 000+ voyageurs dans le monde.',
      quickLinks: 'Liens rapides',
      legal: 'Légal',
      contact: 'Contact',
      home: 'Accueil',
      about: 'À propos',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation',
      refund: 'Politique de remboursement',
      support: 'Support',
      allRightsReserved: 'Tous droits réservés.',
      disclaimer: 'Les billets fictifs sont uniquement pour les demandes de visa et preuve de voyage. Non valable pour un voyage réel.'
    },
    auth: {
      login: 'Connexion',
      register: 'Inscription',
      email: 'E-mail',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: 'Pas de compte ?',
      hasAccount: 'Déjà un compte ?',
      signIn: 'Se connecter',
      signUp: 'S\'inscrire',
      orContinueWith: 'Ou continuer avec'
    },
    orders: {
      title: 'Mes commandes',
      noOrders: 'Aucune commande',
      orderNumber: 'Commande #',
      pnr: 'PNR',
      route: 'Itinéraire',
      date: 'Date',
      status: 'Statut',
      amount: 'Montant',
      download: 'Télécharger PDF',
      viewDetails: 'Voir les détails'
    },
    payment: {
      success: 'Paiement réussi !',
      successMessage: 'Votre billet fictif a été généré et envoyé à votre e-mail.',
      failed: 'Échec du paiement',
      failedMessage: 'Une erreur s\'est produite. Veuillez réessayer.',
      processing: 'Traitement...',
      backToHome: 'Retour à l\'accueil'
    },
    admin: {
      portal: 'Portail admin',
      management: 'Gestion My Dummy Ticket',
      signIn: 'Se connecter au tableau de bord',
      email: 'E-mail admin',
      password: 'Mot de passe',
      dashboard: 'Tableau de bord',
      totalOrders: 'TOTAL COMMANDES',
      activeClients: 'CLIENTS ACTIFS',
      expiredClients: 'CLIENTS EXPIRÉS',
      totalRevenue: 'REVENU TOTAL',
      allTimeBookings: 'Toutes les réservations',
      validTickets: 'Billets valides',
      pastValidity: 'Validité passée',
      fromPaidOrders: 'Des commandes payées',
      paymentOverview: 'Aperçu des paiements',
      success: 'Réussi',
      failed: 'Échoué',
      pending: 'En attente',
      refunded: 'Remboursé',
      notifications: 'Notifications',
      noNotifications: 'Pas de nouvelles notifications',
      notifyMessage: 'Nous vous notifierons quand quelque chose arrivera',
      clearAll: 'Tout effacer',
      enquiries: 'Demandes',
      logout: 'Déconnexion'
    },
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      submit: 'Soumettre',
      cancel: 'Annuler',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      view: 'Voir',
      close: 'Fermer',
      yes: 'Oui',
      no: 'Non',
      or: 'ou',
      and: 'et',
      from: 'de',
      to: 'à'
    },
    seo: {
      title: 'My Dummy Ticket - Billets d\'avion fictifs pour visa',
      description: 'Obtenez des billets d\'avion fictifs professionnels pour les demandes de visa, preuve de voyage et exigences d\'immigration. Livraison instantanée, codes PNR vérifiables.',
      keywords: 'billet fictif, billet d\'avion fictif, demande de visa, preuve de voyage, réservation de vol, immigration, document de voyage, code PNR'
    }
  }
};

// 193 Countries with flags and phone codes
export const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫', phone: '+93' },
  { code: 'AL', name: 'Albania', flag: '🇦🇱', phone: '+355' },
  { code: 'DZ', name: 'Algeria', flag: '🇩🇿', phone: '+213' },
  { code: 'AD', name: 'Andorra', flag: '🇦🇩', phone: '+376' },
  { code: 'AO', name: 'Angola', flag: '🇦🇴', phone: '+244' },
  { code: 'AG', name: 'Antigua and Barbuda', flag: '🇦🇬', phone: '+1-268' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', phone: '+54' },
  { code: 'AM', name: 'Armenia', flag: '🇦🇲', phone: '+374' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', phone: '+61' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹', phone: '+43' },
  { code: 'AZ', name: 'Azerbaijan', flag: '🇦🇿', phone: '+994' },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸', phone: '+1-242' },
  { code: 'BH', name: 'Bahrain', flag: '🇧🇭', phone: '+973' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', phone: '+880' },
  { code: 'BB', name: 'Barbados', flag: '🇧🇧', phone: '+1-246' },
  { code: 'BY', name: 'Belarus', flag: '🇧🇾', phone: '+375' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', phone: '+32' },
  { code: 'BZ', name: 'Belize', flag: '🇧🇿', phone: '+501' },
  { code: 'BJ', name: 'Benin', flag: '🇧🇯', phone: '+229' },
  { code: 'BT', name: 'Bhutan', flag: '🇧🇹', phone: '+975' },
  { code: 'BO', name: 'Bolivia', flag: '🇧🇴', phone: '+591' },
  { code: 'BA', name: 'Bosnia and Herzegovina', flag: '🇧🇦', phone: '+387' },
  { code: 'BW', name: 'Botswana', flag: '🇧🇼', phone: '+267' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', phone: '+55' },
  { code: 'BN', name: 'Brunei', flag: '🇧🇳', phone: '+673' },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬', phone: '+359' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', phone: '+226' },
  { code: 'BI', name: 'Burundi', flag: '🇧🇮', phone: '+257' },
  { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻', phone: '+238' },
  { code: 'KH', name: 'Cambodia', flag: '🇰🇭', phone: '+855' },
  { code: 'CM', name: 'Cameroon', flag: '🇨🇲', phone: '+237' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', phone: '+1' },
  { code: 'CF', name: 'Central African Republic', flag: '🇨🇫', phone: '+236' },
  { code: 'TD', name: 'Chad', flag: '🇹🇩', phone: '+235' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', phone: '+56' },
  { code: 'CN', name: 'China', flag: '🇨🇳', phone: '+86' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', phone: '+57' },
  { code: 'KM', name: 'Comoros', flag: '🇰🇲', phone: '+269' },
  { code: 'CG', name: 'Congo', flag: '🇨🇬', phone: '+242' },
  { code: 'CD', name: 'Congo (DRC)', flag: '🇨🇩', phone: '+243' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', phone: '+506' },
  { code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮', phone: '+225' },
  { code: 'HR', name: 'Croatia', flag: '🇭🇷', phone: '+385' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺', phone: '+53' },
  { code: 'CY', name: 'Cyprus', flag: '🇨🇾', phone: '+357' },
  { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿', phone: '+420' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', phone: '+45' },
  { code: 'DJ', name: 'Djibouti', flag: '🇩🇯', phone: '+253' },
  { code: 'DM', name: 'Dominica', flag: '🇩🇲', phone: '+1-767' },
  { code: 'DO', name: 'Dominican Republic', flag: '🇩🇴', phone: '+1-809' },
  { code: 'EC', name: 'Ecuador', flag: '🇪🇨', phone: '+593' },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', phone: '+20' },
  { code: 'SV', name: 'El Salvador', flag: '🇸🇻', phone: '+503' },
  { code: 'GQ', name: 'Equatorial Guinea', flag: '🇬🇶', phone: '+240' },
  { code: 'ER', name: 'Eritrea', flag: '🇪🇷', phone: '+291' },
  { code: 'EE', name: 'Estonia', flag: '🇪🇪', phone: '+372' },
  { code: 'SZ', name: 'Eswatini', flag: '🇸🇿', phone: '+268' },
  { code: 'ET', name: 'Ethiopia', flag: '🇪🇹', phone: '+251' },
  { code: 'FJ', name: 'Fiji', flag: '🇫🇯', phone: '+679' },
  { code: 'FI', name: 'Finland', flag: '🇫🇮', phone: '+358' },
  { code: 'FR', name: 'France', flag: '🇫🇷', phone: '+33' },
  { code: 'GA', name: 'Gabon', flag: '🇬🇦', phone: '+241' },
  { code: 'GM', name: 'Gambia', flag: '🇬🇲', phone: '+220' },
  { code: 'GE', name: 'Georgia', flag: '🇬🇪', phone: '+995' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', phone: '+49' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', phone: '+233' },
  { code: 'GR', name: 'Greece', flag: '🇬🇷', phone: '+30' },
  { code: 'GD', name: 'Grenada', flag: '🇬🇩', phone: '+1-473' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹', phone: '+502' },
  { code: 'GN', name: 'Guinea', flag: '🇬🇳', phone: '+224' },
  { code: 'GW', name: 'Guinea-Bissau', flag: '🇬🇼', phone: '+245' },
  { code: 'GY', name: 'Guyana', flag: '🇬🇾', phone: '+592' },
  { code: 'HT', name: 'Haiti', flag: '🇭🇹', phone: '+509' },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳', phone: '+504' },
  { code: 'HK', name: 'Hong Kong', flag: '🇭🇰', phone: '+852' },
  { code: 'HU', name: 'Hungary', flag: '🇭🇺', phone: '+36' },
  { code: 'IS', name: 'Iceland', flag: '🇮🇸', phone: '+354' },
  { code: 'IN', name: 'India', flag: '🇮🇳', phone: '+91' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', phone: '+62' },
  { code: 'IR', name: 'Iran', flag: '🇮🇷', phone: '+98' },
  { code: 'IQ', name: 'Iraq', flag: '🇮🇶', phone: '+964' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', phone: '+353' },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', phone: '+972' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', phone: '+39' },
  { code: 'JM', name: 'Jamaica', flag: '🇯🇲', phone: '+1-876' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', phone: '+81' },
  { code: 'JO', name: 'Jordan', flag: '🇯🇴', phone: '+962' },
  { code: 'KZ', name: 'Kazakhstan', flag: '🇰🇿', phone: '+7' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪', phone: '+254' },
  { code: 'KI', name: 'Kiribati', flag: '🇰🇮', phone: '+686' },
  { code: 'KP', name: 'North Korea', flag: '🇰🇵', phone: '+850' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', phone: '+82' },
  { code: 'KW', name: 'Kuwait', flag: '🇰🇼', phone: '+965' },
  { code: 'KG', name: 'Kyrgyzstan', flag: '🇰🇬', phone: '+996' },
  { code: 'LA', name: 'Laos', flag: '🇱🇦', phone: '+856' },
  { code: 'LV', name: 'Latvia', flag: '🇱🇻', phone: '+371' },
  { code: 'LB', name: 'Lebanon', flag: '🇱🇧', phone: '+961' },
  { code: 'LS', name: 'Lesotho', flag: '🇱🇸', phone: '+266' },
  { code: 'LR', name: 'Liberia', flag: '🇱🇷', phone: '+231' },
  { code: 'LY', name: 'Libya', flag: '🇱🇾', phone: '+218' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮', phone: '+423' },
  { code: 'LT', name: 'Lithuania', flag: '🇱🇹', phone: '+370' },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺', phone: '+352' },
  { code: 'MO', name: 'Macau', flag: '🇲🇴', phone: '+853' },
  { code: 'MG', name: 'Madagascar', flag: '🇲🇬', phone: '+261' },
  { code: 'MW', name: 'Malawi', flag: '🇲🇼', phone: '+265' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', phone: '+60' },
  { code: 'MV', name: 'Maldives', flag: '🇲🇻', phone: '+960' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱', phone: '+223' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹', phone: '+356' },
  { code: 'MH', name: 'Marshall Islands', flag: '🇲🇭', phone: '+692' },
  { code: 'MR', name: 'Mauritania', flag: '🇲🇷', phone: '+222' },
  { code: 'MU', name: 'Mauritius', flag: '🇲🇺', phone: '+230' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', phone: '+52' },
  { code: 'FM', name: 'Micronesia', flag: '🇫🇲', phone: '+691' },
  { code: 'MD', name: 'Moldova', flag: '🇲🇩', phone: '+373' },
  { code: 'MC', name: 'Monaco', flag: '🇲🇨', phone: '+377' },
  { code: 'MN', name: 'Mongolia', flag: '🇲🇳', phone: '+976' },
  { code: 'ME', name: 'Montenegro', flag: '🇲🇪', phone: '+382' },
  { code: 'MA', name: 'Morocco', flag: '🇲🇦', phone: '+212' },
  { code: 'MZ', name: 'Mozambique', flag: '🇲🇿', phone: '+258' },
  { code: 'MM', name: 'Myanmar', flag: '🇲🇲', phone: '+95' },
  { code: 'NA', name: 'Namibia', flag: '🇳🇦', phone: '+264' },
  { code: 'NR', name: 'Nauru', flag: '🇳🇷', phone: '+674' },
  { code: 'NP', name: 'Nepal', flag: '🇳🇵', phone: '+977' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', phone: '+31' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', phone: '+64' },
  { code: 'NI', name: 'Nicaragua', flag: '🇳🇮', phone: '+505' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪', phone: '+227' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', phone: '+234' },
  { code: 'MK', name: 'North Macedonia', flag: '🇲🇰', phone: '+389' },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', phone: '+47' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲', phone: '+968' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', phone: '+92' },
  { code: 'PW', name: 'Palau', flag: '🇵🇼', phone: '+680' },
  { code: 'PS', name: 'Palestine', flag: '🇵🇸', phone: '+970' },
  { code: 'PA', name: 'Panama', flag: '🇵🇦', phone: '+507' },
  { code: 'PG', name: 'Papua New Guinea', flag: '🇵🇬', phone: '+675' },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾', phone: '+595' },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', phone: '+51' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', phone: '+63' },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', phone: '+48' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', phone: '+351' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦', phone: '+974' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴', phone: '+40' },
  { code: 'RU', name: 'Russia', flag: '🇷🇺', phone: '+7' },
  { code: 'RW', name: 'Rwanda', flag: '🇷🇼', phone: '+250' },
  { code: 'KN', name: 'Saint Kitts and Nevis', flag: '🇰🇳', phone: '+1-869' },
  { code: 'LC', name: 'Saint Lucia', flag: '🇱🇨', phone: '+1-758' },
  { code: 'VC', name: 'Saint Vincent', flag: '🇻🇨', phone: '+1-784' },
  { code: 'WS', name: 'Samoa', flag: '🇼🇸', phone: '+685' },
  { code: 'SM', name: 'San Marino', flag: '🇸🇲', phone: '+378' },
  { code: 'ST', name: 'São Tomé and Príncipe', flag: '🇸🇹', phone: '+239' },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', phone: '+966' },
  { code: 'SN', name: 'Senegal', flag: '🇸🇳', phone: '+221' },
  { code: 'RS', name: 'Serbia', flag: '🇷🇸', phone: '+381' },
  { code: 'SC', name: 'Seychelles', flag: '🇸🇨', phone: '+248' },
  { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱', phone: '+232' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', phone: '+65' },
  { code: 'SK', name: 'Slovakia', flag: '🇸🇰', phone: '+421' },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮', phone: '+386' },
  { code: 'SB', name: 'Solomon Islands', flag: '🇸🇧', phone: '+677' },
  { code: 'SO', name: 'Somalia', flag: '🇸🇴', phone: '+252' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', phone: '+27' },
  { code: 'SS', name: 'South Sudan', flag: '🇸🇸', phone: '+211' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', phone: '+34' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', phone: '+94' },
  { code: 'SD', name: 'Sudan', flag: '🇸🇩', phone: '+249' },
  { code: 'SR', name: 'Suriname', flag: '🇸🇷', phone: '+597' },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', phone: '+46' },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', phone: '+41' },
  { code: 'SY', name: 'Syria', flag: '🇸🇾', phone: '+963' },
  { code: 'TW', name: 'Taiwan', flag: '🇹🇼', phone: '+886' },
  { code: 'TJ', name: 'Tajikistan', flag: '🇹🇯', phone: '+992' },
  { code: 'TZ', name: 'Tanzania', flag: '🇹🇿', phone: '+255' },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', phone: '+66' },
  { code: 'TL', name: 'Timor-Leste', flag: '🇹🇱', phone: '+670' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬', phone: '+228' },
  { code: 'TO', name: 'Tonga', flag: '🇹🇴', phone: '+676' },
  { code: 'TT', name: 'Trinidad and Tobago', flag: '🇹🇹', phone: '+1-868' },
  { code: 'TN', name: 'Tunisia', flag: '🇹🇳', phone: '+216' },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', phone: '+90' },
  { code: 'TM', name: 'Turkmenistan', flag: '🇹🇲', phone: '+993' },
  { code: 'TV', name: 'Tuvalu', flag: '🇹🇻', phone: '+688' },
  { code: 'UG', name: 'Uganda', flag: '🇺🇬', phone: '+256' },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦', phone: '+380' },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', phone: '+971' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', phone: '+44' },
  { code: 'US', name: 'United States', flag: '🇺🇸', phone: '+1' },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾', phone: '+598' },
  { code: 'UZ', name: 'Uzbekistan', flag: '🇺🇿', phone: '+998' },
  { code: 'VU', name: 'Vanuatu', flag: '🇻🇺', phone: '+678' },
  { code: 'VA', name: 'Vatican City', flag: '🇻🇦', phone: '+39' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪', phone: '+58' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', phone: '+84' },
  { code: 'YE', name: 'Yemen', flag: '🇾🇪', phone: '+967' },
  { code: 'ZM', name: 'Zambia', flag: '🇿🇲', phone: '+260' },
  { code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼', phone: '+263' }
];
